// extracted by mini-css-extract-plugin
export default {"image":"template_image__HsG-Q","textClass":"template_textClass__slOIB","listClass":"template_listClass__yuLh9"};